import { PullToRefreshWrapper } from "~/components/pull-to-refresh-wrapper"
import { QueryBoundary } from "~/components/query-boundary"
import { TitleHeader } from "~/components/title-header"
import { NotificationList } from "./notification-list"

export function NotificationsPage() {
  return (
    <div className="flex flex-col">
      <TitleHeader title="Уведомления" />
      <PullToRefreshWrapper
        className="pb-safe-ios-m"
        useWindowScroll
        queryKeyPrefix={[
          "notifications",
        ]}
      >
        <QueryBoundary>
          <NotificationList />
        </QueryBoundary>
      </PullToRefreshWrapper>
    </div>
  )
}
